module.exports = __webpack_public_path__ + "public/img/noData_ach.a9e84d28.png";